export default function () {
  return {
    items: null,
    isLoading: false,
  };
}
